export default "__VITE_ASSET__BpsRxCzd__"